
import helperMixin from '@/mixin/helper';

export default {
  name: 'to-helper',
  mixins: [helperMixin],
  props: {
    tipsPlacement: {
      type: String,
      default: 'top'
    },
    isMove: {
      type: Boolean,
      default: false
    }
  }
};